import BaseObject from './BaseObject'

class Provider extends BaseObject {
  static _primaryKey = 'provider_id'
  static _apiBaseRoute = 'provider'
  static _objectType = 'provider'
  static _isExportable = true
  static _propConfigs = [
    {
      property_name: 'provider_id'
    },
    {
      property_name: 'first',
      validate: 'required'
    },
    {
      property_name: 'last',
      validate: 'required'
    },
    {
      property_name: 'suffix',
      validate: 'required'
    },
    {
      property_name: 'displayname',
      validate: 'required'
    },
    {
      property_name: 'displayname_short',
      validate: 'required'
    },
    {
      property_name: 'provider_notes'
    },
    {
      property_name: 'email'
    },
    {
      property_name: 'provider_number'
    },
    {
      property_name: 'dea_number'
    },
    {
      property_name: 'phone'
    },
    {
      property_name: 'general'
    },
    {
      property_name: 'license_number'
    },
    {
      property_name: 'non_xtract_provider'
    },
    {
      property_name: 'account',
      relation_class: null,
      relation_class_loader: async function () {
        return await import('./Account')
      },
      relation_type: BaseObject._relationTypes.hasOne,
      validate: 'required'
    },
    {
      property_name: 'address',
      relation_class: null,
      relation_class_loader: async function () {
        return await import('./Address')
      },
      relation_type: BaseObject._relationTypes.hasOne
    }
  ]
  non_xtract_provider = false // default value
  get optionName() {
    return `${this[this._primaryKey]}: ${this.displayname}`
  }
  isEquivalent = item => {
    return (
      this.displayname &&
      item.displayname &&
      this.displayname.toLowerCase() === item.displayname.toLowerCase()
    )
  }
  constructor(row = {}, prefix = '', hasManyPostfix = null) {
    super(row)
    this.prefix = prefix
    this.hasManyPostfix = hasManyPostfix
    if (Object.keys(row).length > 0) {
      this._propConfigs.forEach(propName =>
        this._addPropIfExists(propName, row)
      )
    }
  }
  buildImportableItem = () => {
    const importable = this._clean()
    // make compatibility_class relation
    importable.account = { account_id: this.account.mapped_id }
    if (this.address) {
      importable.address = {
        address_id: this.address.mapped_id,
        ...this.address.buildImportableItem()
      }
    }

    importable.non_xtract_provider = 'F'

    return importable
  }
}

export default Provider
